import Ctrls from "./ctrls";

export default Ctrls;

